import { Dayjs } from 'dayjs'
import { getDateRanges } from './getDateRanges'

export const getStartDate = (): string =>
  (getDateRanges()['last-7-days'] as [Dayjs, Dayjs])[0].toJSON()
